import { render } from "./CategoryWrap.vue?vue&type=template&id=052d6ad5&scoped=true&ts=true"
import script from "./CategoryWrap.vue?vue&type=script&lang=ts"
export * from "./CategoryWrap.vue?vue&type=script&lang=ts"

import "./CategoryWrap.vue?vue&type=style&index=0&id=052d6ad5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052d6ad5"]])

export default __exports__